// extracted by mini-css-extract-plugin
module.exports = {"label":"LoginForm_label__WLteA"};